/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import THEME from '../../themes';

const BannerContainer = styled.div`
  padding: 0 36px 0 0;
  overflow: hidden;

  @media screen and (max-width: 830px){
    padding: 0;
  }
`;

const Container = styled.div`
    position: relative;
    width: 100%;
    max-width: 1200px;
    height: 180px;
    margin: -40px auto 0;
    overflow: visible;

    @media screen and (max-width: 1200px){
      max-width: 100%;
    }

    @media screen and (max-width: 600px){
      margin: -65px auto 0;
    }
`;

const ImageContainer = styled.div`
  height: 200px;
  postion: relative;
  max-width: 1px;
  margin: 0 auto;
  margin-left: calc(50% - 600px);

  img, picture {
    min-width: 1200px;
  }

  @media screen and (max-width: 830px){
    max-width: 100%;
    margin-left: 0;
    img, picture {
      min-width: 600px;
    }
  }

  .bigger {
    img {
      margin-top: -80px;
    }
  }

  .desk {
    @media screen and (max-width: 830px){
      display: none;
    }
  }

  .mobile {
    @media screen and (min-width: 831px){
      display: none;
    }
  }
`;

const UnderRingContainer = styled.div`
  position: absolute;
  top: -260px;
  left: -105px;
  z-index: 0; 
  min-width: 540px;

  @media screen and (max-width: 831px){
    left: calc(50% - 500px);
  }
`;

const OverRingContainer = styled.div`
  position: absolute;
  top: -260px;
  left: -105px;
  z-index: 1; 
  min-width: 220px;
  max-width: 220px;
  overflow: hidden;

  @media screen and (max-width: 831px){
    left: calc(50% - 500px);
  }
`;

const BannerTitle = styled.p`
  text-transform: uppercase;
  line-height: 1.8;
  color: ${THEME.COLORS.WHITE};
  position: absolute;
  top: 30px;
  right: 80px;
  text-shadow: 2px 4px 10px rgba(0,0,0,0.6);
  text-align: right;
  display: flex;
  height: 100px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;

  * {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  strong {
    font: normal normal bold 60px/65px ${THEME.TEXT.FONT_NAME};
  }
  
  @media screen and (max-width: 831px){
    right: 26px;

    strong {
      font: normal normal bold 50px/65px ${THEME.TEXT.FONT_NAME};
    }
  }

  @media screen and (max-width: 380px){
    strong {
      font: normal normal bold 42px/65px ${THEME.TEXT.FONT_NAME};
    }
  }

  @media screen and (max-width: 332px){
    strong {
      font: normal normal bold 38px/65px ${THEME.TEXT.FONT_NAME};
    }
  }
`;

const UnderRing = () => (
  <UnderRingContainer>
    <StaticImage src='../../images/Circulo-Dourado.png' width={540} placeholder="blurred"/>
  </UnderRingContainer>
);

const OverRing = () => (
  <OverRingContainer>
    <div style={{
      position: 'relative', top: 0, left: 0, width: 540,
    }}>
      <StaticImage src='../../images/Circulo-Dourado.png' width={540} placeholder="blurred"/>
    </div>
  </OverRingContainer>
);

const Clinica = () => (
  <>
    <StaticImage className='desk' src='../../images/banners/jpg/Banners-CDABanner-Clinica-Mobile.jpg' alt='Banner "A Clínica"' quality={100}/>
    <StaticImage className='mobile' src='../../images/banners/jpg/Banners-CDABanner-Clinica-DeskTablet.jpg' alt='Banner "A Clínica"' quality={100}/>
  </>
);

const Contato = () => (
  <>
    <StaticImage className='desk' src='../../images/banners/jpg/Banners-CDABanner-Contato-DeskTablet.jpg' alt='Banner "Contato"' quality={100}/>
    <StaticImage className='mobile' src='../../images/banners/jpg/Banners-CDABanner-Contato-DeskTablet.jpg' alt='Banner "Contato"' quality={100}/>
  </>
);

const Tratamentos = () => (
  <>
    <StaticImage className='desk' src='../../images/banners/jpg/Banners-CDABanner-Tratamentos-Mobile.jpg' alt='Banner "Contato"' quality={100}/>
    <StaticImage className='mobile' src='../../images/banners/jpg/Banners-CDABanner-Tratamentos-DeskTablet.jpg' alt='Banner "Contato"' quality={100}/>
  </>
);

const DermatologiaClinica = () => (
  <>
    <StaticImage className='desk bigger' src='../../images/banners/jpg/Banners-CDABH-Clinica-Mobile.jpg' alt='Banner "Contato"' quality={100}/>
    <StaticImage className='mobile bigger' src='../../images/banners/jpg/Banners-CDABH-Clinica-DeskTablet.jpg' alt='Banner "Contato"' quality={100}/>
  </>
);

const DermatologiaCirugica = () => (
  <>
    <StaticImage className='desk bigger' src='../../images/banners/jpg/Banners-CDABH-Cirurgica-Mobile.jpg' alt='Banner "Contato"' quality={100}/>
    <StaticImage className='mobile bigger' src='../../images/banners/jpg/Banners-CDABH-Cirurgica-DeskTablet.jpg' alt='Banner "Contato"' quality={100}/>
  </>
);

const DermatologiaEstetica = () => (
  <>
    <StaticImage className='desk bigger' src='../../images/banners/jpg/Banners-CDABH-Estetica-Mobile.jpg' alt='Banner "Contato"' quality={100}/>
    <StaticImage className='mobile bigger' src='../../images/banners/jpg/Banners-CDABH-Estetica-DeskTablet.jpg' alt='Banner "Contato"' quality={100}/>
  </>
);

// const TratamentosCapilares = () => (
//   <>
//     <StaticImage
//        className='desk bigger'
//        src='../../images/banners/jpg/Banners-CDABH-Capilar-Mobile.jpg'
//        alt='Banner "Contato"' quality={100}/>
//     <StaticImage
//        className='mobile bigger'
//        src='../../images/banners/jpg/Banners-CDABH-Capilar-DeskTablet.jpg'
//        alt='Banner "Contato"' quality={100}/>
//   </>
// );

const selectBanner = (bannerName) => {
  const banners = {
    clinica: Clinica,
    contato: Contato,
    tratamentos: Tratamentos,
    dermClinica: DermatologiaClinica,
    dermCirurgica: DermatologiaCirugica,
    dermEstetica: DermatologiaEstetica,
    tratamentosCapilares: Tratamentos,
  };

  return banners[bannerName]();
};

const Banner = ({ name = 'clinica', children }) => (
    <Container>
        <UnderRing />
        <BannerContainer>
         <ImageContainer>
          {selectBanner(name)}
         </ImageContainer>
         <BannerTitle>
           {children}
         </BannerTitle>
        </BannerContainer>
        <OverRing />
    </Container>
);

export default Banner;
